module.exports = __webpack_public_path__ + "static/content_2_1_eg-f00dea816a3b2df0c03adc0ef376ca51.png";